import { DEVICE_SOURCE_LIST_FAIL, DEVICE_SOURCE_LIST_REQUEST, DEVICE_SOURCE_LIST_SUCCESS, EQUIPMENT_CREATE_REQUEST, EQUIPMENT_CREATE_SUCCESS, EQUIPMENT_DETAILS_CLEAR, EQUIPMENT_DETAILS_REQUEST, EQUIPMENT_DETAILS_SUCCESS, EQUIPMENT_LIST_FAIL, EQUIPMENT_LIST_REQUEST, EQUIPMENT_LIST_SUCCESS, EQUIPMENT_UPDATE_REQUEST, EQUIPMENT_UPDATE_SUCCESS } from "../constants/equipmentConstants"
import { getDeviceSourceList, getEquipmentList, saveEquipment } from "../services/equipmentService";

export const listEquipment = () => async (dispatch) => {
    try {
        dispatch({
            type: EQUIPMENT_LIST_REQUEST
        });

        const data = await getEquipmentList();

        dispatch({
            type: EQUIPMENT_LIST_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: EQUIPMENT_LIST_FAIL,
            payload: error.message
        })
    }
}

export const listDeviceSources = () => async (dispatch) => {
    try {
        dispatch({
            type: DEVICE_SOURCE_LIST_REQUEST
        });

        const data = await getDeviceSourceList();

        dispatch({
            type: DEVICE_SOURCE_LIST_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch({
            type: DEVICE_SOURCE_LIST_FAIL,
            payload: error.message
        })
    }
}

export const getEquipmentDetails = (deviceCode) => async (dispatch, getState) => {
    dispatch({
        type: EQUIPMENT_DETAILS_REQUEST
    });

    const { equipmentList } = getState();

    const equipment = equipmentList.equipment.find(
        x => x.DeviceCode === deviceCode
    );

    dispatch({
        type: EQUIPMENT_DETAILS_SUCCESS,
        payload: equipment
    })
}

export const clearEquipmentDetails = () => ({
    type: EQUIPMENT_DETAILS_CLEAR
});

export const createEquipment = (equipment) => async (dispatch) => {
    dispatch({
        type: EQUIPMENT_CREATE_REQUEST
    });

    await saveEquipment(equipment);

    dispatch({
        type: EQUIPMENT_CREATE_SUCCESS
    })
};

export const updateEquipment = (equipment) => async (dispatch) => {
    dispatch({
        type: EQUIPMENT_UPDATE_REQUEST
    })

    await saveEquipment(equipment)

    dispatch({
        type: EQUIPMENT_UPDATE_SUCCESS
    })
}